import React from "react";
import whyus from "images/whyus.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { globalJson } from "global/global_json";

const WhyChooseUS = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 px-24 gap-12 items-center">
      <div className="space-y-12">
        <h2 className="text-left text-5xl font-bold">
          Have Any Questions About Us?
        </h2>
        <div className="space-x-4">
          <ButtonPrimary className="bg-white hover:bg-white text-primary-100">
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.7711 10.1484C13.9898 10.2578 14.1539 10.5039 14.1539 10.7773C14.1539 10.8047 14.1539 10.8594 14.1539 10.9141L13.4977 13.7578C13.4156 14.0586 13.1695 14.25 12.8688 14.25C5.84141 14.25 0.18125 8.58984 0.18125 1.5625C0.18125 1.26172 0.372656 1.01562 0.673438 0.933594L3.51719 0.277344C3.57188 0.277344 3.62656 0.25 3.65391 0.25C3.92734 0.25 4.17344 0.414062 4.28281 0.660156L5.59531 3.72266C5.62266 3.80469 5.65 3.88672 5.65 3.96875C5.65 4.1875 5.54063 4.37891 5.40391 4.48828L3.73594 5.85547C4.74766 7.98828 6.44297 9.68359 8.57578 10.6953L9.94297 9.02734C10.0523 8.89062 10.2438 8.78125 10.4352 8.78125C10.5445 8.78125 10.6266 8.80859 10.7086 8.83594L13.7711 10.1484Z"
                fill="#18CC3D"
              />
            </svg>{" "}
            {globalJson.phone}
          </ButtonPrimary>
          <ButtonPrimary className="border-white border">
            Contact Us
          </ButtonPrimary>
        </div>
      </div>
      <div>
        <img src={whyus} alt="img" />
      </div>
    </div>
  );
};

export default WhyChooseUS;
